import React, { Component } from "react";
import { connect } from "react-redux";

import $ from "jquery";

import * as sisMapActions from "store/modules/rds_sisMap";

import { Button, Input } from "semantic-ui-react";

import SisModal from "store/sis/sisModal";
import SisSelect from "store/sis/component/SisSelect";
import ColorPicker from "store/sis/component/ColorPicker";

import "./drawShapes.scss";
import { bindActionCreators } from "redux";

class DrawShapes extends Component {
	state = {
		fontSize: 20,
		fontColor: "#000",
	};

	createPoint = () => {
		this.props.sis.sisCreator.createPoint();
	};

	createLine = () => {
		this.props.sis.sisCreator.createLine();
	};

	createPolygon = () => {
		this.props.sis.sisCreator.createPolygon();
	};

	createCircle = () => {
		this.props.sis.sisCreator.createCircle();
	};

	createSquare = () => {
		this.props.sis.sisCreator.createSquare();
	};

	createBox = () => {
		this.props.sis.sisCreator.createBox();
	};

	createStar = () => {
		this.props.sis.sisCreator.createStar();
	};

	createTriangle = () => {
		this.props.sis.sisCreator.createTriangle();
	};

	createText = () => {
		const text = $("#text").val();
		const size = this.state.fontSize;
		const color = this.state.fontColor;

		this.props.sis.sisCreator.createText(text, size, color);
	};

	stopCreator = () => {
		this.props.sis.sisCreator.stop();
	};

	render() {
		let arrFontSize = [];

		for (var i = 8; i <= 30; i++) {
			arrFontSize.push({
				key: i,
				text: i,
			});
		}

		return (
			<div>
				<SisModal
					id={this.props.id}
					title="도형그리기"
					draggable
					closeEvent={this.stopCreator}
					contents={
						<div className="drawTypeWrap">
							<Button onClick={this.createPoint}>점</Button>
							<Button onClick={this.createLine}>선</Button>
							<Button onClick={this.createPolygon}>면</Button>
							<Button onClick={this.createCircle}>원</Button>
							<Button onClick={this.createStar}>별</Button>
							<Button onClick={this.createSquare}>정사각형</Button>
							<Button onClick={this.createBox}>직사각형</Button>
							<Button onClick={this.createTriangle}>정삼각형</Button>

							<div className="textWrap">
								<div className="textOptionWrap">
									<SisSelect
										id="fontSize"
										title="크기"
										items={arrFontSize}
										defaultValue={20}
										onChange={(val) => {
											this.setState({
												fontSize: val,
											});
										}}
									/>

									<ColorPicker
										id="fontColor"
										onChange={(color) => {
											this.setState({
												fontColor: color,
											});
										}}
									/>
								</div>

								<label>
									<Input
										id="text"
										action={{
											content: "텍스트입력",
											onClick: this.createText,
										}}
									/>
								</label>
							</div>
						</div>
					}
				/>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
	})
)(DrawShapes);
